import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b57bafda&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=b57bafda&prod&lang=scss&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&id=b57bafda&prod&lang=scss&"
import style2 from "./detail.vue?vue&type=style&index=2&id=b57bafda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57bafda",
  null
  
)

export default component.exports